import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import { ReleaseViewModel } from '../Registration/Release';
import Form from 'react-jsonschema-form-bs4';
import { JsonForm } from '../Forms/jsonForm';
import arrayFieldTemplate from '../Forms/arrayFieldTemplate';
import Address from '../Forms/fields/address';
import Phone from '../Forms/fields/phone';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    isLoading: boolean;
    index: number;
    Releases: ReleaseViewModel[];
    form: JsonForm|undefined;
    childId: number;
}

export default class ChildGuardians extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            index: 0,
            Releases: [],
            form: undefined,
            childId: 0,
        }

        this.save = this.save.bind(this);
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let childId = parseInt(this.props.match.params.childId) || 0;
        this.requestReleases(childId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let childId = parseInt(nextProps.match.params.childId) || 0;

        if (this.state.Releases && this.state.childId != childId) {
            this.requestReleases(childId);
        }
    }

    public render() {
        return <div>
            <DocumentTitle title="Releases" />
            <br/>
            {this.state.form && <Form
                showErrorList={false}
                schema={this.state.form.Schema}
                uiSchema={this.state.form.UISchema}
                formData={{releases: this.state.Releases}}
                onSubmit={(e) => this.save(e.formData.releases)}
                ArrayFieldTemplate={(props) => arrayFieldTemplate(props, this.delete)}
                fields={{ address: Address, phone: Phone }}
            >
                {!this.state.isLoading && <button type="submit" className="btn btn-primary">Save</button>}
                {this.state.isLoading && <div className="k-loading-image"></div>}
            </Form>}
            <br/>
            <br/>
        </div>
    }

    private requestReleases(childId: number) {
        this.setState({ isLoading: true, childId });
        fetchApi(`api/Children/GetReleases/${childId}`)
            .then((response: { ChildID: number, Releases: ReleaseViewModel[], Form: JsonForm }) => {
                response.Form.Schema = JSON.parse(response.Form.Schema);
                response.Form.UISchema = JSON.parse(response.Form.UISchema);
                this.setState({ isLoading: false, Releases: response.Releases, form: response.Form });
            });
    }

    private save(data: ReleaseViewModel[]) {
        this.setState({ isLoading: true, Releases: data });
        fetchApi(`api/Children/SaveRelease/${this.state.childId}`, data, 'POST')
            .then((response: { Message: string, Errors: Array<{ Field: string, Message: string }> }) => {
                this.setState({ isLoading: false });
            }).catch((error: Error) => {
                this.setState({ isLoading: false });
                // TODO: Show error
            })
    }

    private async delete(data: ReleaseViewModel): Promise<Boolean> {
        if (data.ReleaseID > 0) {
            if (confirm(`Are you sure you want to delete ${data.FirstName} ${data.LastName}?`)) {
                return await fetchApi(`api/Children/DeleteRelease/${data.ReleaseID}`, {}, 'DELETE')
                    .then(() => { return true; })
                    .catch(() => { return false; });
            } else {
                return false;
            }
        } else {
            return true;
        }
    }
}
